import service from "@/plugins/request";

// 小黑盒列表
export function apiQueryList() {
  return service({
    url: "/v1/protected/box/query-list",
    method: "get"
  });
}

// 小黑盒-获取用户基本信息
export function apiGetUserInfo(params) {
  return service({
    url: "/v1/protected/box/detail",
    method: "get",
    params
  });
}

// 小黑盒-获取用户的妮姬
export function apiGetUserNikki(params) {
  return service({
    url: "/v1/protected/box/nikkes",
    method: "get",
    params
  });
}

// 小黑盒-添加用户名
export function apiAddUsername(data) {
  return service({
    url: "/v1/protected/box/add",
    method: "post",
    data
  });
}
// 小黑盒-删除用户名
export function apiDeleteUsername(data) {
  return service({
    url: "/v1/protected/box/delete",
    method: "post",
    data
  });
}
// 小黑盒-添加用户名
export function apiRefreshData(data) {
  return service({
    url: "/v1/protected/box/refresh",
    method: "post",
    data
  });
}

// 小黑盒-搜索用户
export function apiSearchUserList(data) {
  return service({
    url: "/v1/protected/box/search-user",
    method: "post",
    data
  });
}

export function apiDeleteUser(data) {
  return service({
    url: "/v1/protected/box/delete",
    method: "post",
    data
  });
}

/**
 * 获取用户配置
 * @returns
 */
export function apiBoxSettingRead() {
  return service({
    url: "/v1/protected/box/get-setting-config",
    method: "get"
  });
}

/**
 * 保存用户配置
 * @param {*} data
 * @returns
 */
export function apiBoxSettingUpdate(data) {
  return service({
    url: "/v1/protected/box/setting",
    method: "post",
    data
  });
}
